export default __webpack_public_path__ + "static/media/ebate-loader.2b922043.gif";